import generatePDF from "react-to-pdf";
import axiosInstance from "./api_helper";

const clientService = {

    search: async ({ query = '', page = 0, size = 4000 }) => {
        return axiosInstance.get('/api/clients/search', {
            params: { query, page, size }
        });
    },

    findAll: async ({ query = '', page = 0, size = 4000, withSituation = false }) => {
        if (!withSituation) return axiosInstance.get('/api/clients/search/all', { params: { query, page, size } });
        const response = await axiosInstance.get('/api/clients/situations', {
            params: { query, page, size: Math.min(size, 200) }
        });
        response.data.body.content = response.data.body.content.map(({ client, ...totals }) => ({ ...client, ...totals }));
        return response;
    },

    situations: (params, signal) => axiosInstance.get('/api/clients/situations', { params, signal }),
    situation: (id, params, signal) => axiosInstance.get(`/api/clients/situations/${id}`, { params, signal }),



    addClient: async (payload) => {
        return await axiosInstance.post('/api/clients/addClient', payload);

    }
    ,
    importClients: async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        return axiosInstance.post('/api/clients/importer', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    update: async (id, data) => {
        return axiosInstance.put(`/api/clients/${id}`, JSON.stringify(data));
    },
    inactivate: async (id) => {
        return axiosInstance.delete(`/api/clients/${id}`);
    },

    activate: async (id) => {
        return axiosInstance.put(`/api/clients/activer/${id}`);
    },

    generatePDFReleve: async (payload) => {
        const response = await axiosInstance.post(`/api/clients/report`, payload, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    getClientById : async (id) => {
        try {
            return await axiosInstance.get(`/api/clients/${id}`);
        } catch (error) {
            throw error;
        }
    }
};

export default clientService;
